import { motion } from "framer-motion";

interface Props {
  countryCount: number;
}

/**
 * The Atlas wordmark.
 *
 * ⚠⚠ THIS USED TO BE A REAL COMPANY'S. The demo shipped a "Samba TV" wordmark
 * as its masthead beside a procedurally generated catalog — which reads as a
 * client engagement that never happened, and the synthetic-data disclosure at
 * the foot of the page does not undo that: a disclaimer sits UNDER an
 * impersonation, it does not cancel it. Nothing here may carry a name that
 * belongs to someone else. `Atlas` is the project's own, and matches the page
 * title and the portfolio case.
 *
 * Mark: seven bars rising to an apex and falling away — a reading taken across
 * a span, which is what the globe underneath it is doing. It pulses on a
 * staggered 2.4s cycle so the mark has the same continuous life the scene does.
 * Type: "atlas" heavy, a mark-dot, "engine" light.
 */
export default function Chrome({ countryCount }: Props) {
  return (
    <div className="chrome" aria-hidden>
      <motion.div
        className="atlas-logo"
        initial={{ opacity: 0, y: -6 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 0.15 }}
      >
        <svg
          viewBox="0 0 32 22"
          width="38"
          height="26"
          className="atlas-mark"
          role="presentation"
          aria-hidden="true"
        >
          <rect x="0" y="13" width="2.6" height="9" rx="1" />
          <rect x="5" y="8" width="2.6" height="14" rx="1" />
          <rect x="10" y="2" width="2.6" height="20" rx="1" />
          <rect x="15" y="0" width="2.6" height="22" rx="1" />
          <rect x="20" y="5" width="2.6" height="17" rx="1" />
          <rect x="25" y="11" width="2.6" height="11" rx="1" />
          <rect x="29.4" y="18" width="2.6" height="4" rx="1" />
        </svg>
        <div className="atlas-type">
          <span className="atlas-heavy">atlas</span>
          <span className="atlas-accent" aria-hidden>
            ·
          </span>
          <span className="atlas-light">engine</span>
        </div>
        {/* ⚠ This was `<span style={{display:"none"}}>{countryCount}</span>` —
            a prop threaded down from App and then hidden, which is the shape a
            reader recognises as something half-removed. The number is real and
            worth showing: it is `features.length` AFTER Antarctica is filtered
            at load, so it reads 176 against the file's own 177. */}
        <span className="atlas-count">{countryCount} countries</span>
      </motion.div>
    </div>
  );
}
